import React, { useEffect, useRef, useState } from "react";
import { createOverallTest } from "../../helper/apicalls/overallTest";
import "../../styles/common/generateQuestionBankPopup.scss";
import Switch from "@mui/material/Switch";
import Select from "react-select";
import MCQViewer from "./MCQViewer";
import TrueFalseViewer from "./TrueFalseViewer";
import MatchViewer from "./MatchViewer";
import FillUpsViewer from "./FillUpsViewer";
import AnalysisComponent from "./AnalysisComponent";
import {
  GENERATE_CONTENT_NEW_FORMAT_URL,
  GENERATE_CONTENT_NEW_FORMAT_URL_INSTITUTION,
} from "../../helper/apiurls/apiurls";
import Cookies from "js-cookie";
import GlobalLoader from "./GlobalLoader";

const GenerateOverallTestPopup = ({
  open,
  handleClose,
  courseKey,
  onCreated,
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [duration, setDuration] = useState("");
  const [publish, setPublish] = useState(false);
  const [deadline, setDeadline] = useState("");
  const [aiGenerated, setAiGenerated] = useState(false);
  const [generatedItems, setGeneratedItems] = useState([]);

  const [prompt, setPrompt] = useState("");
  const [questionType, setQuestionType] = useState("mcq");
  const testQuestionTypes = [
    { key: "mcq", label: "MCQ" },
    { key: "trueorfalse", label: "True or False" },
    { key: "match", label: "Match" },
    { key: "fillups", label: "Fill Ups" },
    // { key: "analysis", label: "Analysis" },
  ];
  const contentTypeOptions = testQuestionTypes.map((t) => ({
    value: t.key,
    label: t.label,
  }));
  const [testSwitchState, setTestSwitchState] = useState(
    testQuestionTypes.reduce((acc, item) => {
      acc[item.key] = false;
      return acc;
    }, {}),
  );
  const [testQuestionCounts, setTestQuestionCounts] = useState({});
  const websocketRef = useRef(null);
  const institutionToken = Cookies.get("institution_token");
  const adminToken = Cookies.get("admin_token");
  const teacherToken = Cookies.get("teacher_token");
  const token = teacherToken || institutionToken || adminToken || "";

  const [manualMCQContent, setManualMCQContent] = useState({
    questions: [
      {
        question: "",
        options: ["", "", "", ""],
        correctIndex: 0,
        explanation: "",
        hint: "",
      },
    ],
  });

  const [tf, setTf] = useState({
    question: "",
    answer: "true",
    explanation: "",
    hint: "",
  });

  const [manualMatchContent, setManualMatchContent] = useState({
    pairs: [
      {
        left: "",
        right: "",
      },
    ],
  });
  const [matchExplanation, setMatchExplanation] = useState("");
  const [matchHint, setMatchHint] = useState("");

  const [manualFillUpsContent, setManualFillUpsContent] = useState({
    sentences: [
      {
        sentence: "",
        answers: [""],
        explanation: "",
        hint: "",
      },
    ],
  });

  const [analysis, setAnalysis] = useState({
    title: "",
    content: "",
    hint: "",
  });

  const [showPreview, setShowPreview] = useState(false);
  const [websocketStatus, setWebsocketStatus] = useState("");

  useEffect(() => {
    if (open) {
      setActiveTab(0);
      setName("");
      setSaving(false);
      setError("");
      setPrompt("");
      setQuestionType("mcq");
      setDuration("");
      setPublish(false);
      setDeadline("");
      setAiGenerated(false);
      setGeneratedItems([]);
      setTestSwitchState(
        testQuestionTypes.reduce((acc, item) => {
          acc[item.key] = false;
          return acc;
        }, {}),
      );
      setTestQuestionCounts({});
      setManualMCQContent({
        questions: [
          {
            question: "",
            options: ["", "", "", ""],
            correctIndex: 0,
            explanation: "",
            hint: "",
          },
        ],
      });
      setTf({ question: "", answer: "true", explanation: "", hint: "" });
      setManualMatchContent({
        pairs: [
          {
            left: "",
            right: "",
          },
        ],
      });
      setMatchExplanation("");
      setMatchHint("");
      setManualFillUpsContent({
        sentences: [
          {
            sentence: "",
            answers: [""],
            explanation: "",
            hint: "",
          },
        ],
      });
      setAnalysis({ title: "", content: "", hint: "" });
      setWebsocketStatus("");
    }
  }, [open]);

  const handleAddMCQQuestion = () => {
    setManualMCQContent((prev) => ({
      ...prev,
      questions: [
        ...prev.questions,
        {
          question: "",
          options: ["", "", "", ""],
          correctIndex: 0,
          explanation: "",
          hint: "",
        },
      ],
    }));
  };

  const handleRemoveMCQQuestion = (index) => {
    setManualMCQContent((prev) => ({
      ...prev,
      questions: prev.questions.filter((_, i) => i !== index),
    }));
  };

  const handleAddMatchPair = () => {
    setManualMatchContent((prev) => ({
      ...prev,
      pairs: [...prev.pairs, { left: "", right: "" }],
    }));
  };

  const handleRemoveMatchPair = (index) => {
    setManualMatchContent((prev) => ({
      ...prev,
      pairs: prev.pairs.filter((_, i) => i !== index),
    }));
  };

  const handleMatchPairChange = (index, side, value) => {
    setManualMatchContent((prev) => ({
      ...prev,
      pairs: prev.pairs.map((pair, i) =>
        i === index ? { ...pair, [side]: value } : pair,
      ),
    }));
  };

  const handleAddFillUpsSentence = () => {
    setManualFillUpsContent((prev) => ({
      ...prev,
      sentences: [
        ...prev.sentences,
        { sentence: "", answers: [""], explanation: "", hint: "" },
      ],
    }));
  };

  const handleRemoveFillUpsSentence = (index) => {
    setManualFillUpsContent((prev) => ({
      ...prev,
      sentences: prev.sentences.filter((_, i) => i !== index),
    }));
  };

  const handleFillUpsSentenceChange = (index, field, value) => {
    setManualFillUpsContent((prev) => ({
      ...prev,
      sentences: prev.sentences.map((sentence, i) =>
        i === index ? { ...sentence, [field]: value } : sentence,
      ),
    }));
  };

  const handleAddFillUpsAnswer = (sentenceIndex) => {
    setManualFillUpsContent((prev) => ({
      ...prev,
      sentences: prev.sentences.map((sentence, i) =>
        i === sentenceIndex
          ? { ...sentence, answers: [...(sentence.answers || []), ""] }
          : sentence,
      ),
    }));
  };

  const handleRemoveFillUpsAnswer = (sentenceIndex, answerIndex) => {
    setManualFillUpsContent((prev) => ({
      ...prev,
      sentences: prev.sentences.map((sentence, i) =>
        i === sentenceIndex
          ? {
              ...sentence,
              answers: (sentence.answers || []).filter(
                (_, j) => j !== answerIndex,
              ),
            }
          : sentence,
      ),
    }));
  };

  const handleFillUpsAnswerChange = (sentenceIndex, answerIndex, value) => {
    setManualFillUpsContent((prev) => ({
      ...prev,
      sentences: prev.sentences.map((sentence, i) =>
        i === sentenceIndex
          ? {
              ...sentence,
              answers: (sentence.answers || []).map((answer, j) =>
                j === answerIndex ? value : answer,
              ),
            }
          : sentence,
      ),
    }));
  };

  if (!open) return null;

  const buildContent = () => {
    if (activeTab === 0) {
      return Array.isArray(generatedItems) ? generatedItems : [];
    }
    switch (questionType) {
      case "mcq": {
        const questions = manualMCQContent?.questions || [];
        return questions.map((q) => {
          const optionsArr = q.options || [];
          const optionsObj = {};
          optionsArr.forEach((opt, index) => {
            optionsObj[String.fromCharCode(65 + index)] = opt || "";
          });
          const ci =
            typeof q.correctIndex === "number" &&
            q.correctIndex >= 0 &&
            q.correctIndex < optionsArr.length
              ? q.correctIndex
              : 0;
          const correctLabel = String.fromCharCode(65 + ci);
          return {
            type: "mcq",
            question: q.question || "",
            options: optionsObj,
            answer: correctLabel,
            explanation: q.explanation || "",
            hint: q.hint || "",
          };
        });
      }
      case "trueorfalse":
        return [
          {
            type: "trueorfalse",
            question: tf.question,
            options: { A: "True", B: "False" },
            answer:
              (tf.answer || "true").toString().toLowerCase() === "true"
                ? "A"
                : "B",
            explanation: tf.explanation,
            hint: tf.hint || "",
          },
        ];
      case "match": {
        const pairs = manualMatchContent?.pairs || [];
        const leftValues = pairs.map((p) => p.left || "");
        const rightValues = pairs.map((p) => p.right || "");
        return [
          {
            type: "match",
            pairs: [
              { key: "Column 1", values: leftValues },
              { key: "Column 2", values: rightValues },
            ],
            explanation: matchExplanation || "",
            hint: matchHint || "",
          },
        ];
      }
      case "fillups": {
        const sentences = manualFillUpsContent?.sentences || [];
        return sentences.map((s) => ({
          type: "fillups",
          question: s.sentence || "",
          answer:
            (Array.isArray(s.answers) && s.answers.length > 0
              ? s.answers[0]
              : "") || "",
          explanation: s.explanation || "",
          hint: s.hint || "",
        }));
      }
      case "analysis":
        return [
          {
            type: "analysis",
            question: analysis.title,
            explanation: analysis.content,
            hint: analysis.hint || "",
          },
        ];
      default:
        return [];
    }
  };

  const normalizeGeneratedToItems = (resultsArray) => {
    const items = [];
    resultsArray.forEach((r) => {
      const structured = r?.data?.structured;
      const questions = structured?.questions;
      if (Array.isArray(questions)) {
        questions.forEach((q) => {
          const t = q?.type || questionType || "mcq";
          if (t === "mcq") {
            // options could be array or object
            let optionsObj = {};
            const options = q.options || q.content?.options || [];
            if (Array.isArray(options)) {
              options.forEach((opt, idx) => {
                if (typeof opt === "object" && opt !== null) {
                  const k =
                    Object.keys(opt)[0] || String.fromCharCode(65 + idx);
                  optionsObj[k] = Object.values(opt)[0];
                } else {
                  optionsObj[String.fromCharCode(65 + idx)] = opt;
                }
              });
            } else if (options && typeof options === "object") {
              optionsObj = options;
            }
            const answer = q.answer || q.content?.answer;
            items.push({
              type: "mcq",
              question: q.question || q.content?.question || "",
              options: optionsObj,
              answer: typeof answer === "string" ? answer : "A",
              explanation: q.explanation || q.content?.explanation || "",
              hint: q.hint || q.content?.hint || "",
            });
          } else if (t === "trueorfalse") {
            const raw = (q.answer || q.content?.answer || "true")
              .toString()
              .toLowerCase();
            const answer = raw === "true" || raw === "a" ? "A" : "B";
            items.push({
              type: "trueorfalse",
              question: q.question || q.content?.question || "",
              options: { A: "True", B: "False" },
              answer,
              explanation: q.explanation || q.content?.explanation || "",
              hint: q.hint || q.content?.hint || "",
            });
          } else if (t === "match") {
            const pairs =
              q.pairs ||
              q.content?.pairs ||
              q.questions ||
              q.content?.questions ||
              [];
            items.push({
              type: "match",
              pairs,
              explanation: q.explanation || q.content?.explanation || "",
              hint: q.hint || q.content?.hint || "",
            });
          } else if (t === "fillups") {
            items.push({
              type: "fillups",
              question: q.question || q.content?.question || "",
              answer: q.answer || q.content?.answer || "",
              explanation: q.explanation || q.content?.explanation || "",
              hint: q.hint || q.content?.hint || "",
            });
          } else if (t === "analysis") {
            items.push({
              type: "analysis",
              question: q.question || q.content?.question || "",
              explanation: q.explanation || q.content?.explanation || "",
              hint: q.hint || q.content?.hint || "",
            });
          }
        });
      }
    });
    return items;
  };

  const startGeneration = async () => {
    if (!prompt.trim()) {
      setError("Please enter a prompt");
      return;
    }
    try {
      setSaving(true);
      setError("");
      setAiGenerated(false);
      if (websocketRef.current) {
        websocketRef.current.close();
      }
      const role = Cookies.get("role");
      const socketUrl = (role === "institution" || role === "teacher")
        ? GENERATE_CONTENT_NEW_FORMAT_URL_INSTITUTION
        : GENERATE_CONTENT_NEW_FORMAT_URL;
      websocketRef.current = new WebSocket(socketUrl);
      websocketRef.current.onopen = () => {
        const typesArr = [];
        testQuestionTypes.forEach((item) => {
          const enabled = testSwitchState[item.key];
          const countNum = Number(testQuestionCounts[item.key] || 0);
          if (enabled && Number.isFinite(countNum) && countNum > 0) {
            typesArr.push({ type: item.key, count: countNum });
          }
        });
        if (typesArr.length === 0) {
          typesArr.push({ type: questionType || "mcq", count: 1 });
        }
        const message = {
          prompt: prompt.trim(),
          types: typesArr,
          field: "course",
          key: (courseKey || "").trim(),
          token: token,
        };
        websocketRef.current.send(JSON.stringify(message));
      };
      websocketRef.current.onmessage = async (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data?.status) {
            setWebsocketStatus(data.status);
          }
          if (Array.isArray(data?.results)) {
            const items = normalizeGeneratedToItems(data.results);
            setGeneratedItems(items);
          }
        } catch (e) {
          console.log(e);
        } finally {
          setAiGenerated(true);
          setSaving(false);
        }
      };
      websocketRef.current.onerror = () => {
        setError("Failed to connect to generator service");
        setSaving(false);
      };
      websocketRef.current.onclose = () => {};
    } catch (e) {
      setError("Failed to start generation");
      setSaving(false);
    }
  };

  const onSave = async () => {
    const trimmedName = (name || "").trim() || "Untitled Overall Test";
    try {
      if (activeTab === 0 && !aiGenerated) {
        await startGeneration();
        return;
      }
      setSaving(true);
      setError("");
      const content = buildContent().map((item, idx) => ({
        ...item,
        sequence: item.sequence !== undefined ? item.sequence : idx + 1,
        categories: item.categories || "",
        hint: item.hint || "",
      }));
      const payload = { name: trimmedName, content };
      if (courseKey && typeof courseKey === "string" && courseKey.trim()) {
        payload.course = courseKey.trim();
      }
      if (duration && String(duration).trim()) {
        const num = Number(duration);
        payload.duration = Number.isFinite(num) ? num : duration;
      }
      if (deadline && deadline.trim()) {
        const dt = new Date(deadline);
        if (!isNaN(dt.getTime())) {
          payload.deadline = dt.toISOString();
        } else {
          payload.deadline = deadline;
        }
      }
      const created = await createOverallTest(payload);
      if (onCreated) onCreated(created);
      if (handleClose) handleClose();
    } catch (e) {
      setError("Failed to create overall test. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  const onBackdrop = (e) => {
    if (e.target === e.currentTarget && handleClose) handleClose();
  };

  // Derived validation flags (excluding content type)
  const trimmedName = (name || "").trim();
  const isNameValid = !!trimmedName;

  const hasDuration = !!String(duration || "").trim();
  const durationNum = Number(duration);
  const isDurationValid =
    !hasDuration || (Number.isFinite(durationNum) && durationNum > 0);

  const hasDeadline = !!(deadline && deadline.trim());
  const deadlineDate = hasDeadline ? new Date(deadline) : null;
  const isDeadlineValid = !hasDeadline || !Number.isNaN(deadlineDate.getTime());

  const promptTrimmed = (prompt || "").trim();
  const isPromptValid = !!promptTrimmed;

  const aiHasGeneratedContent =
    Array.isArray(generatedItems) && generatedItems.length > 0;

  let manualHasContent = false;
  if (activeTab === 1) {
    const built = buildContent();
    manualHasContent = Array.isArray(built) && built.length > 0;
  }

  let isPrimaryDisabled = saving;

  if (activeTab === 0) {
    if (!aiGenerated) {
      // Generate with AI button state
      isPrimaryDisabled =
        saving ||
        websocketStatus === "processing" ||
        !isNameValid ||
        !isPromptValid ||
        !isDurationValid ||
        !isDeadlineValid;
    } else {
      // After generation, behaves like Save
      isPrimaryDisabled =
        saving ||
        !isNameValid ||
        !isDurationValid ||
        !isDeadlineValid ||
        !aiHasGeneratedContent;
    }
  } else {
    // Manual tab Save button state
    isPrimaryDisabled =
      saving ||
      !isNameValid ||
      !isDurationValid ||
      !isDeadlineValid ||
      !manualHasContent;
  }

  return (
    <>
      {saving && <GlobalLoader visible={saving} text="Loading..." />}

      <div className="qb-generator-popup high-z-index" onClick={onBackdrop}>
        <div className="qb-generator-dialog">
          <div className="qb-generator-header">
            <h2 className="qb-generator-title">Create Overall Test</h2>
            <button className="qb-generator-close" onClick={handleClose}>
              ×
            </button>
          </div>

          <div className="qb-generator-tabs">
            <div
              className={`qb-generator-tab ${activeTab === 0 ? "active" : ""}`}
              onClick={() => setActiveTab(0)}
            >
              Generate with AI
            </div>
            <div
              className={`qb-generator-tab ${activeTab === 1 ? "active" : ""}`}
              onClick={() => setActiveTab(1)}
            >
              Manual
            </div>
          </div>

          <div className="qb-generator-row">
            <div className="qb-generator-field" style={{ width: "70%" }}>
              <label className="qb-generator-label">Name</label>
              <input
                type="text"
                className="qb-generator-input"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter overall test name"
              />
            </div>
            <div className="qb-generator-field" style={{ width: "30%" }}>
              <label className="qb-generator-label">Duration</label>
              <input
                type="text"
                className="qb-generator-input"
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
                placeholder="e.g. 30 mins"
              />
            </div>
          </div>

          <div className="qb-generator-row">
            {activeTab === 1 && (
              <div className="qb-generator-field" style={{ width: "50%" }}>
                <label className="qb-generator-label">Content Type</label>
                <Select
                  className="content-generator-select"
                  classNamePrefix="content-generator-select"
                  options={contentTypeOptions}
                  value={contentTypeOptions.find(
                    (o) => o.value === questionType,
                  )}
                  onChange={(opt) => setQuestionType(opt?.value || "mcq")}
                  isSearchable={false}
                  components={{ IndicatorSeparator: null }}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: 40,
                      height: 40,
                      borderRadius: 4,
                      backgroundColor: "var(--color-bg)",
                      borderColor: state.isFocused
                        ? "var(--color-primary)"
                        : "var(--border-color)",
                      boxShadow: "none",
                      ":hover": { borderColor: "var(--color-primary)" },
                      fontSize: "var(--fs-md)",
                      color: "var(--color-text-dark)",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: "var(--color-text-dark)",
                      fontSize: "var(--fs-md)",
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: "var(--color-text-light)",
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 10002,
                      backgroundColor: "var(--color-bg)",
                      border: "1px solid var(--border-color)",
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isFocused
                        ? "var(--color-hover)"
                        : "transparent",
                      color: "var(--color-text-dark)",
                    }),
                  }}
                />
              </div>
            )}
            <div
              className="qb-generator-field"
              style={{ width: activeTab === 1 ? "50%" : "100%" }}
            >
              <label className="qb-generator-label">Deadline</label>
              <input
                type="datetime-local"
                className="qb-generator-input"
                value={deadline}
                onChange={(e) => setDeadline(e.target.value)}
              />
            </div>
          </div>

          {activeTab === 0 ? (
            <div className="qb-generator-content">
              <div className="qb-generator-tab-content active">
                <div className="input-section">
                  <div className="prompt-section">
                    <textarea
                      className="prompt-textarea"
                      placeholder="Enter a prompt to generate questions for this test"
                      value={prompt}
                      onChange={(e) => setPrompt(e.target.value)}
                    />
                  </div>
                  <div className="qb-question-types">
                    <div className="qb-question-types-label qb-generator-label">
                      Question Types & Count
                    </div>
                    {testQuestionTypes.map((item) => (
                      <div key={item.key} className="qb-question-type-row">
                        <div className="qb-question-type-name">
                          {item.label}
                        </div>
                        <Switch
                          size="small"
                          checked={!!testSwitchState[item.key]}
                          onChange={() =>
                            setTestSwitchState((prev) => ({
                              ...prev,
                              [item.key]: !prev[item.key],
                            }))
                          }
                        />
                        <input
                          type="number"
                          min="1"
                          className={`qb-question-type-count-input ${
                            testSwitchState[item.key] ? "visible" : "hidden"
                          }`}
                          placeholder="No.of Count"
                          value={(
                            testQuestionCounts[item.key] ?? ""
                          ).toString()}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^0-9]/g, "");
                            setTestQuestionCounts((prev) => ({
                              ...prev,
                              [item.key]: value,
                            }));
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="qb-generator-content">
              <div className="qb-generator-tab-content active">
                <div className="input-section">
                  {questionType === "mcq" && (
                    <div className="manual-mcq-content">
                      <h3 className="mcq-title">MCQ Questions</h3>
                      {manualMCQContent.questions.map((q, index) => (
                        <div key={index} className="mcq-question">
                          <input
                            className="question-input"
                            placeholder={`Question ${index + 1}`}
                            value={q.question || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              setManualMCQContent((prev) => ({
                                ...prev,
                                questions: prev.questions.map((qq, i) =>
                                  i === index ? { ...qq, question: val } : qq,
                                ),
                              }));
                            }}
                          />
                          {(q.options || []).map((option, optIndex) => (
                            <div key={optIndex} className="option-row">
                              <input
                                type="radio"
                                className="option-radio"
                                checked={q.correctIndex === optIndex}
                                onChange={() => {
                                  setManualMCQContent((prev) => ({
                                    ...prev,
                                    questions: prev.questions.map((qq, i) =>
                                      i === index
                                        ? { ...qq, correctIndex: optIndex }
                                        : qq,
                                    ),
                                  }));
                                }}
                              />
                              <input
                                className="option-input"
                                placeholder={`Option ${String.fromCharCode(
                                  65 + optIndex,
                                )}`}
                                value={option || ""}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  setManualMCQContent((prev) => ({
                                    ...prev,
                                    questions: prev.questions.map((qq, i) => {
                                      if (i !== index) return qq;
                                      const opts = [...(qq.options || [])];
                                      opts[optIndex] = val;
                                      return { ...qq, options: opts };
                                    }),
                                  }));
                                }}
                              />
                              {q.options && q.options.length > 1 && (
                                <button
                                  className="option-delete-btn"
                                  onClick={() => {
                                    setManualMCQContent((prev) => ({
                                      ...prev,
                                      questions: prev.questions.map((qq, i) => {
                                        if (i !== index) return qq;
                                        const opts = (qq.options || []).filter(
                                          (_, oi) => oi !== optIndex,
                                        );
                                        let newCorrectIndex = qq.correctIndex;
                                        if (optIndex < qq.correctIndex) {
                                          newCorrectIndex = Math.max(
                                            0,
                                            qq.correctIndex - 1,
                                          );
                                        } else if (
                                          optIndex === qq.correctIndex
                                        ) {
                                          newCorrectIndex = Math.min(
                                            opts.length - 1,
                                            qq.correctIndex,
                                          );
                                        }
                                        return {
                                          ...qq,
                                          options: opts,
                                          correctIndex: newCorrectIndex,
                                        };
                                      }),
                                    }));
                                  }}
                                >
                                  ×
                                </button>
                              )}
                            </div>
                          ))}
                          <button
                            className="add-option-btn"
                            onClick={() => {
                              setManualMCQContent((prev) => ({
                                ...prev,
                                questions: prev.questions.map((qq, i) =>
                                  i === index
                                    ? {
                                        ...qq,
                                        options: [...(qq.options || []), ""],
                                      }
                                    : qq,
                                ),
                              }));
                            }}
                          >
                            + Add Option
                          </button>
                          <textarea
                            className="explanation-textarea"
                            placeholder="Explanation"
                            value={q.explanation || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              setManualMCQContent((prev) => ({
                                ...prev,
                                questions: prev.questions.map((qq, i) =>
                                  i === index
                                    ? { ...qq, explanation: val }
                                    : qq,
                                ),
                              }));
                            }}
                          />
                          <textarea
                            className="explanation-textarea"
                            placeholder="Hint (optional)"
                            value={q.hint || ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              setManualMCQContent((prev) => ({
                                ...prev,
                                questions: prev.questions.map((qq, i) =>
                                  i === index ? { ...qq, hint: val } : qq,
                                ),
                              }));
                            }}
                            style={{ marginTop: 8 }}
                          />
                          {manualMCQContent.questions.length > 1 && (
                            <div style={{ marginTop: 16 }}>
                              <button
                                className="remove-question-btn"
                                onClick={() => handleRemoveMCQQuestion(index)}
                              >
                                Remove Question
                              </button>
                            </div>
                          )}
                        </div>
                      ))}
                      <button
                        className="add-question-btn"
                        onClick={handleAddMCQQuestion}
                      >
                        + Add Question
                      </button>
                    </div>
                  )}

                  {questionType === "trueorfalse" && (
                    <div className="manual-truefalse-content">
                      <div className="tf-question">
                        <input
                          className="question-input"
                          placeholder={`Question`}
                          value={tf.question}
                          onChange={(e) =>
                            setTf((prev) => ({
                              ...prev,
                              question: e.target.value,
                            }))
                          }
                        />
                        <div className="tf-answer">
                          <div
                            className={`tf-option ${
                              (tf.answer || "true").toString().toLowerCase() ===
                              "true"
                                ? "correct"
                                : ""
                            }`}
                            onClick={() =>
                              setTf((prev) => ({ ...prev, answer: "true" }))
                            }
                          >
                            <input
                              type="radio"
                              className="tf-radio"
                              checked={
                                (tf.answer || "true")
                                  .toString()
                                  .toLowerCase() === "true"
                              }
                              onChange={() =>
                                setTf((prev) => ({ ...prev, answer: "true" }))
                              }
                            />
                            True
                          </div>
                          <div
                            className={`tf-option ${
                              (tf.answer || "true").toString().toLowerCase() ===
                              "false"
                                ? "correct"
                                : ""
                            }`}
                            onClick={() =>
                              setTf((prev) => ({ ...prev, answer: "false" }))
                            }
                          >
                            <input
                              type="radio"
                              className="tf-radio"
                              checked={
                                (tf.answer || "true")
                                  .toString()
                                  .toLowerCase() === "false"
                              }
                              onChange={() =>
                                setTf((prev) => ({ ...prev, answer: "false" }))
                              }
                            />
                            False
                          </div>
                        </div>
                        <div
                          className="qb-generator-field"
                          style={{ width: "100%", paddingTop: 12 }}
                        >
                          <label className="qb-generator-label">
                            Explanation
                          </label>
                          <textarea
                            className="explanation-textarea qb-generator-input"
                            placeholder="Explanation"
                            value={tf.explanation}
                            onChange={(e) =>
                              setTf((prev) => ({
                                ...prev,
                                explanation: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div
                          className="qb-generator-field"
                          style={{ width: "100%" }}
                        >
                          <label className="qb-generator-label">Hint</label>
                          <textarea
                            className="explanation-textarea qb-generator-input"
                            placeholder="Hint"
                            value={tf.hint}
                            onChange={(e) =>
                              setTf((prev) => ({
                                ...prev,
                                hint: e.target.value,
                              }))
                            }
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  {questionType === "match" && (
                    <div className="manual-match-content">
                      <h3 className="match-title">Match Pairs</h3>
                      {manualMatchContent.pairs.map((pair, index) => (
                        <div key={index} className="match-pair">
                          <input
                            className="match-left-input"
                            placeholder="Left side"
                            value={pair.left}
                            onChange={(e) =>
                              handleMatchPairChange(
                                index,
                                "left",
                                e.target.value,
                              )
                            }
                          />
                          <input
                            className="match-right-input"
                            placeholder="Right side"
                            value={pair.right}
                            onChange={(e) =>
                              handleMatchPairChange(
                                index,
                                "right",
                                e.target.value,
                              )
                            }
                          />
                          {manualMatchContent.pairs.length > 1 && (
                            <button
                              className="remove-pair-btn"
                              onClick={() => handleRemoveMatchPair(index)}
                            >
                              Remove Pair
                            </button>
                          )}
                        </div>
                      ))}
                      <button
                        className="add-pair-btn"
                        onClick={handleAddMatchPair}
                      >
                        + Add Pair
                      </button>
                    </div>
                  )}

                  {questionType === "fillups" && (
                    <div className="manual-fillups-content">
                      <h3 className="fillups-title">Fill in the Blanks</h3>
                      {manualFillUpsContent.sentences.map((sentence, index) => (
                        <div key={index} className="fillups-sentence">
                          <textarea
                            className="sentence-textarea"
                            placeholder="Sentence with blanks represented by underscores, e.g., 'The capital of France is ____.'"
                            value={sentence.sentence}
                            onChange={(e) =>
                              handleFillUpsSentenceChange(
                                index,
                                "sentence",
                                e.target.value,
                              )
                            }
                          />
                          <div className="answers-section">
                            <h4>Answers:</h4>
                            {sentence.answers.map((answer, ansIndex) => (
                              <div key={ansIndex} className="answer-input">
                                <input
                                  type="text"
                                  placeholder={`Answer ${ansIndex + 1}`}
                                  value={answer}
                                  onChange={(e) =>
                                    handleFillUpsAnswerChange(
                                      index,
                                      ansIndex,
                                      e.target.value,
                                    )
                                  }
                                />
                                {sentence.answers.length > 1 && (
                                  <button
                                    className="remove-answer-btn"
                                    onClick={() =>
                                      handleRemoveFillUpsAnswer(index, ansIndex)
                                    }
                                  >
                                    Remove
                                  </button>
                                )}
                              </div>
                            ))}
                            <button
                              className="add-answer-btn"
                              onClick={() => handleAddFillUpsAnswer(index)}
                            >
                              + Add Answer
                            </button>
                          </div>
                          <div
                            className="qb-generator-field"
                            style={{ width: "100%", paddingTop: 12 }}
                          >
                            <label className="qb-generator-label">
                              Explanation
                            </label>
                            <textarea
                              className="explanation-textarea qb-generator-input"
                              placeholder="Explanation"
                              value={sentence.explanation || ""}
                              onChange={(e) =>
                                handleFillUpsSentenceChange(
                                  index,
                                  "explanation",
                                  e.target.value,
                                )
                              }
                            />
                          </div>
                          <div
                            className="qb-generator-field"
                            style={{ width: "100%" }}
                          >
                            <label className="qb-generator-label">Hint</label>
                            <textarea
                              className="explanation-textarea qb-generator-input"
                              placeholder="Hint"
                              value={sentence.hint || ""}
                              onChange={(e) =>
                                handleFillUpsSentenceChange(
                                  index,
                                  "hint",
                                  e.target.value,
                                )
                              }
                            />
                          </div>
                          {manualFillUpsContent.sentences.length > 1 && (
                            <div style={{ marginTop: 16 }}>
                              <button
                                className="remove-question-btn"
                                onClick={() =>
                                  handleRemoveFillUpsSentence(index)
                                }
                              >
                                Remove Sentence
                              </button>
                            </div>
                          )}
                        </div>
                      ))}
                      <button
                        className="add-question-btn"
                        onClick={handleAddFillUpsSentence}
                      >
                        + Add Sentence
                      </button>
                    </div>
                  )}

                  {questionType === "analysis" && (
                    <div className="manual-analysis-content">
                      <input
                        className="analysis-title-input"
                        placeholder={`Title`}
                        value={analysis.title}
                        onChange={(e) =>
                          setAnalysis((prev) => ({
                            ...prev,
                            title: e.target.value,
                          }))
                        }
                      />
                      <div
                        className="qb-generator-field"
                        style={{ width: "100%", paddingTop: 12 }}
                      >
                        <label className="qb-generator-label">
                          Explanation
                        </label>
                        <textarea
                          className="explanation-textarea qb-generator-input"
                          placeholder="Content"
                          value={analysis.content}
                          onChange={(e) =>
                            setAnalysis((prev) => ({
                              ...prev,
                              content: e.target.value,
                            }))
                          }
                        />
                      </div>
                      <div
                        className="qb-generator-field"
                        style={{ width: "100%" }}
                      >
                        <label className="qb-generator-label">Hint</label>
                        <textarea
                          className="explanation-textarea qb-generator-input"
                          placeholder="Hint"
                          value={analysis.hint}
                          onChange={(e) =>
                            setAnalysis((prev) => ({
                              ...prev,
                              hint: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="qb-generator-actions">
            {/* <button
              type="button"
              className="qb-action-btn"
              onClick={handleClose}
              disabled={saving}
            >
              Cancel
            </button> */}
            {activeTab === 0 &&
              aiGenerated &&
              Array.isArray(generatedItems) &&
              generatedItems.length > 0 && (
                <button
                  type="button"
                  className="qb-action-btn primary"
                  onClick={() => setShowPreview(true)}
                  disabled={saving}
                >
                  Preview
                </button>
              )}
            <button
              type="button"
              className="qb-action-btn primary"
              onClick={onSave}
              disabled={isPrimaryDisabled}
            >
              {activeTab === 0
                ? websocketStatus === "processing"
                  ? "Generating..."
                  : saving
                    ? "Saving..."
                    : !aiGenerated
                      ? "Generate"
                      : "Save"
                : saving
                  ? "Saving..."
                  : "Save"}
            </button>
          </div>
          {showPreview && activeTab === 0 && (
            <div
              className="qb-preview-overlay"
              style={{
                position: "fixed",
                inset: 0,
                backgroundColor: "rgba(0,0,0,0.4)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 10010,
              }}
              onClick={() => setShowPreview(false)}
            >
              <div
                className="qb-preview-dialog"
                style={{
                  position: "relative",
                  backgroundColor: "var(--color-bg, #fff)",
                  borderRadius: 8,
                  maxWidth: 800,
                  width: "90%",
                  maxHeight: "80vh",
                  display: "flex",
                  flexDirection: "column",
                  boxShadow:
                    "0 10px 30px rgba(15, 23, 42, 0.25), 0 0 0 1px rgba(15, 23, 42, 0.08)",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="qb-preview-header">
                  <h3
                    className="qb-preview-title"
                    style={{
                      margin: 0,
                      padding: "16px 20px",
                      borderBottom: "1px solid var(--border-color, #e2e8f0)",
                      fontSize: "var(--fs-lg, 16px)",
                      fontWeight: 600,
                    }}
                  >
                    Generated Questions Preview
                  </h3>
                  <button
                    type="button"
                    className="qb-preview-close"
                    style={{
                      position: "absolute",
                      top: 8,
                      right: 12,
                      border: "none",
                      background: "transparent",
                      fontSize: 20,
                      cursor: "pointer",
                      lineHeight: 1,
                    }}
                    onClick={() => setShowPreview(false)}
                  >
                    ×
                  </button>
                </div>
                <div
                  className="qb-preview-body"
                  style={{ padding: 16, overflowY: "auto" }}
                >
                  {Array.isArray(generatedItems) &&
                  generatedItems.length > 0 ? (
                    <div className="qb-preview-viewers">
                      {generatedItems.map((item, idx) => {
                        const t = (item.type || "").toString().toLowerCase();
                        switch (t) {
                          case "mcq":
                            return (
                              <div key={idx} style={{ marginBottom: 16 }}>
                                <MCQViewer questionData={item} />
                              </div>
                            );
                          case "trueorfalse":
                            return (
                              <div key={idx} style={{ marginBottom: 16 }}>
                                <TrueFalseViewer questionData={item} />
                              </div>
                            );
                          case "match":
                            return (
                              <div key={idx} style={{ marginBottom: 16 }}>
                                <MatchViewer questionData={item} />
                              </div>
                            );
                          case "fillups":
                            return (
                              <div key={idx} style={{ marginBottom: 16 }}>
                                <FillUpsViewer questionData={item} />
                              </div>
                            );
                          case "analysis":
                            return (
                              <div key={idx} style={{ marginBottom: 16 }}>
                                <AnalysisComponent data={item} />
                              </div>
                            );
                          default:
                            return (
                              <div
                                key={idx}
                                style={{
                                  marginBottom: 12,
                                  padding: 12,
                                  borderRadius: 6,
                                  border:
                                    "1px solid var(--border-color, #e2e8f0)",
                                  fontSize: "var(--fs-md, 14px)",
                                }}
                              >
                                {item.question || "(Unsupported item type)"}
                              </div>
                            );
                        }
                      })}
                    </div>
                  ) : (
                    <div
                      className="qb-preview-empty"
                      style={{
                        fontSize: "var(--fs-md, 14px)",
                        color: "var(--color-text-light, #64748b)",
                        textAlign: "center",
                        padding: 24,
                      }}
                    >
                      No generated items to preview.
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default GenerateOverallTestPopup;
